import EcoSpace from 'eco-design/base/eco-space';
import styles from './index.module.scss';
import EcoSection from 'eco-design/base/eco-section';
import { useLang } from '@/i18n';
import { createPortal } from 'react-dom';
import EcoTab, { EcoTabItemProps } from 'eco-design/elements/eco-tab';
import { useEffect, useRef, useState } from 'react';
import EcoImgVideo from 'eco-design/base/eco-img-video';
import { LeftIcon2, RightIcon2 } from '../icons';
import gtm from '@/utils/gtm';
import Modal from './Modal';
import { Navigation, EffectFade } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

const F: React.FC = () => {
    const { t } = useLang('Delta3AirSeries.F');
    const [selectIndex, setSelectIndex] = useState(0);
    const [modalOpen, setModalOpen] = useState(false);
    const swiperRef = useRef<any>(null);
    const handleOpenModal = () => {
        setModalOpen(true);
        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            list_name: t('title'),
            button_name: t('btn'),
            __btn_id1: `F-content .btn`,
            __btn_id2: t('btn'),
            __btn_type: 'text',
        });
    };
    const tabItems = [
        {
            tabValue: t('item_tab1'),
            tabLabel: t('item_tab1'),
        },

        { tabValue: t('item_tab2'), tabLabel: t('item_tab2') },
        {
            tabValue: t('item_tab3'),
            tabLabel: t('item_tab3'),
        },
    ];

    const onTabChange = (item: EcoTabItemProps, index: number) => {
        setSelectIndex(index);
        setActiveItem({ ...items[index] });
        swiperRef.current?.slideTo(index);
        // swiperRef.current.updateAutoHeight(300);
    };

    const items = [
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1763522073757/Kitchen.jpg',
            padImg: 'https://websiteoss.ecoflow.com/upload/image/1763522163065/a.jpg',
            tips: t('item1_tips'),
            text: [
                {
                    title: t('item1_title_1'),
                    subTitle: t('item1_subTitle_1'),
                    desc: t('item1_desc_1'),
                },
                {
                    title: t('item1_title_2'),
                    subTitle: t('item1_subTitle_2'),
                    desc: t('item1_desc_2'),
                },
                {
                    title: t('item1_title_3'),
                    subTitle: t('item1_subTitle_3'),
                    desc: t('item1_desc_3'),
                },
                {
                    title: t('item1_title_4'),
                    subTitle: t('item1_subTitle_4'),
                    desc: t('item1_desc_4'),
                },
                {
                    title: t('item1_title_5'),
                    subTitle: t('item1_subTitle_5'),
                    desc: t('item1_desc_5'),
                },
                {
                    title: t('item1_title_6'),
                    subTitle: t('item1_subTitle_6'),
                    desc: t('item1_desc_6'),
                },
            ],
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1763522074447/work.jpg',
            padImg: 'https://websiteoss.ecoflow.com/upload/image/1763522163276/b.jpg',
            tips: t('item2_tips'),
            text: [
                {
                    title: t('item2_title_1'),
                    subTitle: t('item2_subTitle_1'),
                    desc: t('item2_desc_1'),
                },
                {
                    title: t('item2_title_2'),
                    subTitle: t('item2_subTitle_2'),
                    desc: t('item2_desc_2'),
                },
                {
                    title: t('item2_title_3'),
                    subTitle: t('item2_subTitle_3'),
                    desc: t('item2_desc_3'),
                },
                {
                    title: t('item2_title_4'),
                    subTitle: t('item2_subTitle_4'),
                    desc: t('item2_desc_4'),
                },
                {
                    title: t('item2_title_5'),
                    subTitle: t('item2_subTitle_5'),
                    desc: t('item2_desc_5'),
                },
                {
                    title: t('item2_title_6'),
                    subTitle: t('item2_subTitle_6'),
                    desc: t('item2_desc_6'),
                },
            ],
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1763522073959/outdoor.jpg',
            padImg: 'https://websiteoss.ecoflow.com/upload/image/1763522163583/c.jpg',
            tips: t('item3_tips'),
            text: [
                {
                    title: t('item3_title_1'),
                    subTitle: t('item3_subTitle_1'),
                    desc: t('item3_desc_1'),
                },
                {
                    title: t('item3_title_2'),
                    subTitle: t('item3_subTitle_2'),
                    desc: t('item3_desc_2'),
                },
                {
                    title: t('item3_title_3'),
                    subTitle: t('item3_subTitle_3'),
                    desc: t('item3_desc_3'),
                },
                {
                    title: t('item3_title_4'),
                    subTitle: t('item3_subTitle_4'),
                    desc: t('item3_desc_4'),
                },
                {
                    title: t('item3_title_5'),
                    subTitle: t('item3_subTitle_5'),
                    desc: t('item3_desc_5'),
                },
                {
                    title: t('item3_title_6'),
                    subTitle: t('item3_subTitle_6'),
                    desc: t('item3_desc_6'),
                },
            ],
        },
    ];
    const defaultItem = items[0] || {};
    const [activeItem, setActiveItem] = useState(defaultItem);

    const iconChange = (type: string) => {
        const index = type === 'left' ? selectIndex - 1 : selectIndex + 1;
        setSelectIndex(index);
        setActiveItem({ ...items[index] });
        swiperRef.current?.slideTo(index);
        // swiperRef.current.updateAutoHeight(300);
        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            list_name: t('title'),
            button_name: `icon${type === 'left' ? 'L' : 'R'}`,
            __btn_id1: `F-content .${type}`,
            __btn_id2: `icon${type === 'left' ? 'L' : 'R'}`,
            __btn_type: 'text',
        });
    };
    const [load, setLoad] = useState(true);

    // useEffect(() => {
    //     if (typeof window !== 'undefined') {
    //         const secneF = AniContainer.create({
    //             triggerElement: '.range2',
    //             triggerHook: 1,
    //             onEnter: () => setLoad(true),
    //         });
    //         return () => {
    //             secneF.destroy();
    //         };
    //     }
    // }, []);
    // 点击切换
    return (
        <section className={`${styles.F} GtmModuleData-section range3`} id="List-sence-C" data-section-id="D3A-F">
            <EcoSpace />
            <div className="F-content">
                <EcoSection title={t('title')} desc={t('desc')} />
                <EcoTab items={tabItems} className={`F-tab`} activeIndex={selectIndex} onChange={onTabChange} />
                <div className="F-box">
                    <div className="E-text">
                        {activeItem.text.map((item) => {
                            return (
                                <div>
                                    <p className="title">
                                        {item.title} <span className="subTitle">{item.subTitle}</span>{' '}
                                    </p>
                                    <p className="desc">{item.desc}</p>
                                </div>
                            );
                        })}
                    </div>
                    {/* <div className="item-img">{load && <EcoImgVideo pc={activeItem.img} h5={activeItem.padImg} loop={true} />}</div> */}
                    <div className="item-img">

                        <Swiper
                            modules={[Navigation, EffectFade]}
                            onSwiper={(swiper) => (swiperRef.current = swiper)}
                            effect={'fade'}
                            speed={600}
                            centeredSlides={true}
                            slidesPerView={'auto'}
                            allowTouchMove={false} // 🚫 禁止触摸滑动
                            simulateTouch={false} // 🚫 禁止鼠标拖动
                            keyboard={{ enabled: false }} // 🚫 禁止键盘操作
                            mousewheel={false} // 🚫 禁止滚轮操作
                        >
                            {items.map((item: any, index: number) => (
                                <SwiperSlide key={index} className="swiper-slide">
                                    <EcoImgVideo className={`${index === selectIndex ? 'active' : ''}`} pc={item.img} h5={item.padImg} loop={true} />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>

                    <div className="img-tips">
                        <p> {activeItem.tips}</p>
                        <div className="icon">
                            <div className={`left ${selectIndex <= 0 ? 'disabled' : ''}`} onClick={() => selectIndex > 0 && iconChange('left')}>
                                <LeftIcon2></LeftIcon2>
                            </div>
                            <div
                                className={`right ${selectIndex >= items.length - 1 ? 'disabled' : ''}`}
                                onClick={() => selectIndex < items.length - 1 && iconChange('right')}
                            >
                                <RightIcon2 className="right"></RightIcon2>
                            </div>
                        </div>
                    </div>
                </div>
                <p className="tips">{t('tips')}</p>
                <div className="btn-ani">
                    <span className="btn GtmModuleData-btn-text" onClick={handleOpenModal}>
                        {t('btn')}
                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                            <g clip-path="url(#clip0_8136_17)">
                                <path
                                    d="M14 26C20.6274 26 26 20.6274 26 14C26 7.37258 20.6274 2 14 2C7.37258 2 2 7.37258 2 14C2 20.6274 7.37258 26 14 26Z"
                                    fill="black"
                                />
                                <path d="M9.625 14H18.375" stroke="white" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M14 9.625V18.375" stroke="white" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                                <clipPath id="clip0_8136_17">
                                    <rect width="28" height="28" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </span>
                </div>
            </div>
            {modalOpen && createPortal(<Modal callback={() => setModalOpen(false)}></Modal>, document.body)}
            <EcoSpace />
        </section>
    );
};
export default F;
